import { TreeStructure } from "@via/components/tree-structure/tree-structure.tsx";
import type { TreeData } from "@via/utils/interfaces.tsx";
import { RunReportResource } from "common";
import { useEffect, useState, type JSX } from "react";
import type { NodeApi } from "react-arborist";

export function ReportResourceNavigation({
  reportTree,
  onReportSelect,
  selectedReport,
  openByDefault,
}: {
  reportTree: RunReportResource[];
  onReportSelect: (report: RunReportResource) => void;
  selectedReport: RunReportResource | undefined;
  openByDefault: boolean;
}): JSX.Element {
  const [selection, setSelection] = useState<string | undefined>(
    selectedReport?.id
  );

  useEffect(() => {
    setSelection(selectedReport?.id);
  }, [selectedReport]);

  const onItemSelect = (node: Array<NodeApi<TreeData>>) => {
    const selectedReport = node[0]?.data || null;
    if (selectedReport) {
      onReportSelect(selectedReport as RunReportResource);
      setSelection(selectedReport.id);
    }
  };

  return (
    <TreeStructure
      openByDefault={openByDefault}
      disableFolderSelection
      selection={selection}
      treeData={reportTree}
      onSelect={onItemSelect}
    />
  );
}
